<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-首页">
    <div class="swipe">
      <el-carousel :interval="4000" indicator-position="none" height="calc(100vh)" arrow="always">
        <!-- <el-carousel :interval="5000" height="600" arrow="always"> -->
        <el-carousel-item v-for="item in focusData" :key="item.photo">
          <img style="width:100%;height:100%" :src="item.photo" alt />
        </el-carousel-item>
      </el-carousel>
      <div class="sTitle">
        <h1>解码中医悬疑、揭示中医奥秘、诠释中医渊源、探索中医本质</h1>
        <!-- <p>我们的基本目标实现四个基本目标</p> -->
      </div>
    </div>
    <div class="program">
      <div class="showSomeProgram">
        <div class="pHeader">
          <div class="pleft"></div>
          <div class="pcenter"></div>
          <div class="pright"></div>
        </div>
        <h2>PROJECT PRESENTATION</h2>
        <h1>项目展示</h1>
        <div class="pwrapper">
          <div class="allProgram">
            <div
              :style="pcurrentIndex==0?'':pcurrentIndex==Math.ceil(pnav.length / 4)-1?`left:${-6.42*(pcurrentIndex-1)-6.42/4*(pnav.length % 4)}rem`:`left:${-6.42*pcurrentIndex}rem`"
              class="showProgram"
            >
              <div
                class="pContent"
                :style="realPcurrentIndex==index?'color:#ff7233;border-bottom-width:0.04rem':''"
                v-for="(item,index) in pnav"
                :key="index"
              >
                <img ref="imghead" :src="item.picture" alt />
                <p
                  :style="realPcurrentIndex==index?'color:#ff7233':''"
                  @click="ptoLink(item,index)"
                >{{item.name}}</p>
              </div>
            </div>
          </div>
          <!-- <div :style="`left:${1.62*pscurrentIndex+0.26+0.04*pcurrentIndex}rem`" class="pnavline"></div> -->
          <div
            :style="pcurrentIndex==0?'display:none;':''"
            @click="ptoLeft"
            v-if="pnav.length>4"
            class="pLeft el-icon-arrow-left"
          ></div>
          <div
            :style="pcurrentIndex==Math.ceil(pnav.length / 4)-1?'display:none;':''"
            @click="ptoRight"
            v-if="pnav.length>4"
            class="pRight el-icon-arrow-right"
          ></div>
        </div>
        <div class="pLine"></div>
        <div class="pabs">
          <div class="pabsContent">
            <p>{{pnav[realPcurrentIndex].pageview}}</p>
          </div>
          <h4
            @click="$router.push({name:'program',params:{id:pnav[realPcurrentIndex].id,index:realPcurrentIndex}})"
          >查看详情 -></h4>
        </div>
      </div>
    </div>
    <div class="news wow fadeInUp" data-wow-duration="1s">
      <div class="nHeader">
        <img :src="`${BASE_URL}static/bg/banner1.png`" alt />
      </div>
      <div class="newsWrapper">
        <div class="newsLeft">
          <div class="newsLfetContent">
            <h2>NEWS INFORMATION</h2>
            <h1>新闻资讯</h1>
            <div class="video">
              <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                @pause="pausePlay($event)"
                :options="playerOptions"
              ></video-player>
            </div>
            <div class="newsLeftContentTime">
              <p>时间: {{showNewsData.putime}}</p>
              <p>浏览量: {{showNewsData.countpublic}}</p>
            </div>
            <div class="newsLeftContentTitle">
              <h3 @click="$router.push(`/newsContent/${showNewsData.id}`)">{{showNewsData.name}}</h3>
            </div>
            <div class="firstNews" v-html="showNewsData.content"></div>
            <h4 @click="$router.push(`/newsContent/${showNewsData.id}`)">查看详情 -></h4>
          </div>
        </div>
        <div class="newsRight">
          <div class="newsRightNav">
            <div ref="line" :style="`left:${1.1*currentIndex}rem`" class="line"></div>
            <ul>
              <li ref="he" v-for="(item,index) in nav" :key="index">
                <h2
                  :style="index==currentIndex?'color:#fff;':''"
                  @click="toLink(item,index)"
                >{{item.title}}</h2>
              </li>
            </ul>
          </div>
          <div class="newsRightWrapper">
            <div class="newsRightContent" v-for="(item,index) in newsData" :key="index">
              <h3 @click="$router.push(`/newsContent/${item.id}`)">{{item.name}}</h3>
              <div class="newsRightContentTime">
                <p>时间: {{item.putime}}</p>
                <p>浏览量: {{item.countpublic}}</p>
              </div>
            </div>
            <h5 @click="$router.push('/news')">查看全部新闻动态 -></h5>
          </div>
        </div>
      </div>
    </div>
    <div class="compution wow fadeInUp" data-wow-duration="1s">
      <h2>COOPERATIVE ORGANIZATION</h2>
      <h1>合作机构</h1>
      <div class="allCom">
        <div
          class="comContent"
          :style="comCurrentIndex==Math.ceil(comData.length / 5)-1?`left:${-8.54*(comCurrentIndex-1)-8.54/5*(comData.length - 5 * comCurrentIndex)}rem`:`left:${-8.54*comCurrentIndex}rem`"
        >
          <div
            data-wow-duration=".5s"
            :data-wow-delay="index/4+'s'"
            class="comWrapper wow fadeInLeft"
            v-for="(item,index) in comData"
            :key="index"
          >
            <a :href="'http://'+item.link" target="_blank" rel="noopener noreferrer">
              <img :src="item.path" :title="item.name" alt />
            </a>
          </div>
        </div>
      </div>
      <div
        :style="comCurrentIndex==0?'display:none;':''"
        @click="toLeft"
        class="comLeft el-icon-arrow-left"
      ></div>
      <div
        :style="comCurrentIndex==Math.ceil(comData.length / 5)-1?'display:none;':''"
        @click="toRight"
        class="comRight el-icon-arrow-right"
      ></div>
      <div class="getMore" @click="$router.push('/computions')">查看更多</div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/utils/base.js";
import { getFocus, getCom } from "@/api/home.js";
import { getNews } from "@/api/news.js";
import { videoPlayer } from "vue-video-player";
import { getProgram } from "@/api/product.js";
import objectFitImages from "object-fit-images"
import WOW from "wowjs";
export default {
  name: "Home",
  data() {
    return {
      nav: [
        {
          title: "行业动态",
          url: "/news"
        },
        {
          title: "机构动态",
          url: "/goods"
        },
        {
          title: "项目动态",
          url: "/center"
        },
        {
          title: "活动展示",
          url: "/hdzs"
        }
      ],
      pnav: [{}],
      newsData: [],
      comData: [],
      currentIndex: 0,
      pcurrentIndex: 0,
      pscurrentIndex: 0,
      realPcurrentIndex: 0,
      comCurrentIndex: 0,
      focusData: [],
      showNewsData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: ""
          }
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  created() {
    this.getProgram();
    this.BASE_URL = BASE_URL;
  },
  mounted() {
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: true,
        live: true
      });
      wow.init();
    }, 200);
    this.getFocus();
    this.getCom();
    this.getAllNewsData();
    this.getNewsData();
    objectFitImages( this.$refs.imghead)
  },
  //在页面离开时记录滚动位置
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem(
      "home_ps",
      document.documentElement.scrollTop || document.body.scrollTop
    );
    next();
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      window.scrollTo({
        top: sessionStorage.getItem("home_ps")
      });
      // window.scrollTo({
      //   top: sessionStorage.getItem("home_ps"),
      //   behavior: "smooth"
      // });
      // document.body.scrollTop = sessionStorage.getItem("home_ps");
      sessionStorage.clear("home_ps");
    });
  },
  methods: {
    // 获取轮播图
    async getFocus() {
      let focus = await getFocus();
      this.focusData = focus.filter(item => {
        return (item.photo = BASE_URL + item.photo);
      });
    },
    // 获取项目
    async getProgram() {
      let program = await getProgram();
      this.pnav = program.filter(item => {
        return (item.picture = BASE_URL + item.picture);
      });
    },
    // 获取合作机构
    async getCom() {
      let coms = new FormData();
      coms.append("page", 1);
      coms.append("rows", 1000);
      let com = await getCom(coms);
      this.comData = com.rows;
      this.comData.map(item => {
        return (item.path = BASE_URL + item.path);
      });
    },
    // 获取新闻动态
    async getAllNewsData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 50);
      news.append("xueyuan", "倒");
      let note = await getNews(news);
      note.rows.forEach(ele => {
        if (ele.journalism) {
          this.showNewsData = ele;
            this.playerOptions.sources[0].src =BASE_URL+ this.showNewsData.journalism;
          return false;
        }
      });
    },
    // 获取新闻动态
    async getNewsData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 50);
      news.append("xueyuan", "倒");
      news.append("dentity", this.nav[this.currentIndex].title);
      let note = await getNews(news);
      this.newsData = note.rows;
      this.newsData = this.newsData.filter((item, index) => {
        if (item.journalism) {
          item.journalism = BASE_URL + item.journalism;
        }
        return index < 5;
      });
    },
    // 新闻动态切换
    toLink(item, index) {
      this.currentIndex = index;
      this.getNewsData();
    },
    // 点击切换
    ptoLink(item, index) {
      this.realPcurrentIndex = index;
      if (this.pcurrentIndex == Math.ceil(this.pnav.length / 4) - 1) {
        this.pscurrentIndex = 4 - this.pnav.length + index;
      } else {
        this.pscurrentIndex = index % 4;
      }
    },
    // 合作机构向左
    toLeft() {
      if (this.comCurrentIndex == 0) {
        this.comCurrentIndex = 0;
      } else {
        this.comCurrentIndex--;
      }
    },
    // 合作机构向右
    toRight() {
      if (this.comCurrentIndex == Math.ceil(this.comData.length / 5) - 1) {
        this.comCurrentIndex = Math.ceil(this.comData.length / 5) - 1;
      } else {
        this.comCurrentIndex++;
      }
    },
    // 项目向左
    ptoLeft() {
      if (this.pcurrentIndex == 0) {
        this.pcurrentIndex = 0;
      } else {
        this.pcurrentIndex--;
      }
    },
    // 项目向右
    ptoRight() {
      if (this.pcurrentIndex == Math.ceil(this.pnav.length / 4) - 1) {
        this.pcurrentIndex = Math.ceil(this.pnav.length / 4) - 1;
      } else {
        this.pcurrentIndex++;
      }
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause();
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: { videoPlayer }
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    position: relative;
    /deep/.el-carousel__container .el-carousel__arrow--left {
      z-index: 102;
    }
    /deep/.el-carousel__container .el-carousel__arrow--right {
      z-index: 102;
    }
    .sTitle {
      height: 100%;
      z-index: 10;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.2);
      text-align: center;
      color: #ffffff;
      h1 {
        margin-top: calc(35vh);
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 50px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  .program {
    position: relative;
    padding-bottom: 42px;
    background-color: #fafafa;
    width: 100%;
    height: 420px;
    .showSomeProgram {
      background-color: #fff;
      width: 854px;
      margin: 0 auto;
      height: 600px;
      box-shadow: 2px 2px 6px #ccc;
      position: absolute;
      top: -180px;
      z-index: 12;
      text-align: center;
      left: calc((100% - 854px) / 2);
      .pHeader {
        height: 20px;
        display: flex;
        justify-content: space-between;
        .pleft {
          width: 160px;
          background-color: #0588c7;
        }
        .pcenter {
          margin: 0 5px;
          flex: 1;
          background-color: #f5f5f5;
        }
        .pright {
          width: 160px;
          background-color: #ff7233;
        }
      }

      h2 {
        font-size: 16px;
        color: #3c3c3c;
        margin-top: 40px;
      }
      h1 {
        font-size: 24px;
        color: #000;
        margin: 10px 0 40px;
      }
      .pwrapper {
        width: 648px;
        margin: 0 auto;
        height: 150px;
        // margin-bottom: 10px;
        position: relative;
        .pnavline {
          width: 110px;
          height: 4px;
          background-color: #fe7333;
          position: absolute;
          transition: 0.3s all linear;
          left: 0;
          bottom: -10px;
        }
        .allProgram {
          width: 648px;
          height: 150px;
          margin: 0 auto;
          overflow: hidden;
          position: relative;
          .showProgram {
            position: absolute;
            left: 0;
            top: 0;
            width: 30000px;
            display: flex;
            transition: 0.5s linear all;
            .pContent {
              width: 110px;
              margin: 0px 26px;
              text-align: center;
              border-bottom: 0px solid #fe7333;
              padding-bottom: 10px;
              img {
                object-fit: cover;
                font-family: "object-fit: cover;";
                width: 90px;
                height: 90px;
                border-radius: 50%;
                margin-bottom: 10px;
              }
              p {
                color: #000;
                font-size: 14px;
                line-height: 1.3;
                cursor: pointer;
              }
            }
          }
        }
        .pLeft {
          position: absolute;
          left: -36px;
          top: 60px;
          font-size: 24px;
          cursor: pointer;
        }
        .pRight {
          position: absolute;
          right: -36px;
          top: 60px;
          font-size: 24px;
          cursor: pointer;
        }
      }
      .pLine {
        width: 100%;
        height: 2px;
        background-color: #f5f5f5;
      }
      .pabs {
        width: 620px;
        margin: 60px auto 0;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #000;
        .pabsContent {
          height: 126px;
          overflow: hidden;
          p {
            flex: 1;
            line-height: 1.5;
            text-align: left;
          }
        }
        h4 {
          display: flex;
          margin-top: 20px;
          justify-content: flex-end;
          cursor: pointer;
          &:hover {
            color: #ff7233;
          }
        }
      }
    }
  }
  .news {
    width: 100%;
    .nHeader {
      width: 100%;
      height: 200px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .newsWrapper {
      width: 100%;
      height: 640px;
      display: flex;
      align-items: flex-end;
      .newsLeft {
        width: 44%;
        height: 100%;
        padding-top: 60px;
        display: flex;
        justify-content: flex-end;
        background-color: #376095;
        .newsLfetContent {
          margin-right: 44px;
          width: 330px;
          h2 {
            font-size: 16px;
            color: #fefffc;
            margin: 20px 0 10px;
          }
          h1 {
            font-size: 24px;
            color: #fff;
            margin-bottom: 40px;
          }
          .video {
            height: 190px;
            width: 100%;
          }
          .newsLeftContentTime {
            margin: 20px 0;
            display: flex;
            font-size: 14px;
            justify-content: space-between;
            p {
              line-height: 1;
            }
          }
          .newsLeftContentTitle {
            margin-bottom: 20px;
            h3 {
              font-size: 20px;
              color: #fff;
              line-height: 1.5;
              word-break: break-all;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
          }
          .firstNews {
            max-height: 84px;
            overflow: hidden;
            color: #d5d5d5;
            line-height: 1.5;
            font-size: 14px;
          }
          h4 {
            font-size: 14px;
            cursor: pointer;
            color: #fff;
            margin-top: 30px;
            &:hover {
              color: #ff7233;
            }
          }
        }
      }
      .newsRight {
        width: 56%;
        height: 100%;
        background-color: #4a77b3;
        padding-left: 60px;
        .newsRightNav {
          margin-bottom: 40px;
          margin-top: 40px;
          position: relative;
          .line {
            width: 70px;
            height: 2px;
            background-color: #fff;
            position: absolute;
            transition: 0.3s all linear;
            left: 0;
            bottom: -6px;
          }
          ul {
            display: flex;
            align-items: center;
            color: #d5d5d5;
            li {
              width: 70px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              margin-right: 40px;
              font-size: 16px;
              h2 {
                margin-bottom: 10px;
                cursor: pointer;
              }
            }
          }
        }
        .newsRightWrapper {
          width: 460px;
          .newsRightContent {
            width: 100%;
            border-bottom: 1px dotted #fff;
            h3 {
              font-size: 16px;
              color: #fff;
              margin-top: 20px;
              cursor: pointer;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow:ellipsis;
              &:hover {
                text-decoration: underline;
              }
            }
            .newsRightContentTime {
              margin: 20px 0;
              display: flex;
              justify-content: space-between;
              p {
                line-height: 1;
                font-size: 14px;
                color: #d5d5d5;
              }
            }
          }
          h5 {
            display: flex;
            justify-content: flex-end;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
            margin-top: 30px;
            &:hover {
              color: #ff7233;
            }
          }
        }
      }
    }
  }
  .compution {
    width: 100%;
    background-color: #fafafa;
    text-align: center;
    padding-bottom: 60px;
    position: relative;

    h2 {
      font-size: 16px;
      padding-top: 56px;
      color: #000;
      margin: 0px 0 10px;
    }
    h1 {
      font-size: 24px;
      color: #0588c9;
      margin-bottom: 40px;
    }
    .allCom {
      width: 854px;
      margin: 0 auto;
      overflow: hidden;
      height: 152px;
      position: relative;
      .comContent {
        width: 30008px;
        display: flex;
        height: 150px;
        position: absolute;
        top: 0;
        left: 0;
        transition: 0.5s linear all;
        .comWrapper {
          width: 150px;
          height: 150px;
          margin-right: 20px;
          background-color: #fff;
          border: #aaa solid 1px;
          display: flex;
          justify-content: center;
          align-items: center;
          a {
            img {
              width: 100px;
              height: 100px;
              line-height: 150px;
              text-align: center;
              transition: 0.5s all linear;
              &:hover {
                transform: scale(1.1);
              }
            }
          }
        }
      }
    }
    .comLeft {
      position: absolute;
      left: calc(50vw - 460px);
      top: 210px;
      font-size: 24px;
      cursor: pointer;
    }
    .comRight {
      position: absolute;
      right: calc(50vw - 460px);
      top: 210px;
      font-size: 24px;
      cursor: pointer;
    }
    .getMore {
      margin: 40px auto;
      font-size: 16px;
      color: #000;
      cursor: pointer;
      border: 1px solid #aaa;
      width: 110px;
      height: 30px;
      line-height: 30px;
      border-radius: 2px;
      &:hover {
        background-color: #ff7233;
        color: #fff;
        border-color: #fff;
      }
    }
  }
}
</style>